var React = require('react');

function CloseMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27 2.79523L24.3049 0.100098L13.5234 10.8815L2.74201 0.100098L0.046875 2.79523L10.8283 13.5767L0.046875 24.3581L2.74201 27.0532L13.5234 16.2718L24.3049 27.0532L27 24.3581L16.2186 13.5767L27 2.79523Z","fill":"#041E42"}));
}

CloseMenu.defaultProps = {"width":"27","height":"28","viewBox":"0 0 27 28","fill":"none"};

module.exports = CloseMenu;

CloseMenu.default = CloseMenu;
